/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInstituteRequest
 */
export interface UpdateInstituteRequest {
    /**
     * Full name of the institute.
     * @type {string}
     * @memberof UpdateInstituteRequest
     */
    instituteName: string;
    /**
     * Short display name of the institute.
     * @type {string}
     * @memberof UpdateInstituteRequest
     */
    instituteShortName: string;
}

/**
 * Check if a given object implements the UpdateInstituteRequest interface.
 */
export function instanceOfUpdateInstituteRequest(value: object): value is UpdateInstituteRequest {
    if (!('instituteName' in value) || value['instituteName'] === undefined) return false;
    if (!('instituteShortName' in value) || value['instituteShortName'] === undefined) return false;
    return true;
}

export function UpdateInstituteRequestFromJSON(json: any): UpdateInstituteRequest {
    return UpdateInstituteRequestFromJSONTyped(json, false);
}

export function UpdateInstituteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstituteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteName': json['instituteName'],
        'instituteShortName': json['instituteShortName'],
    };
}

export function UpdateInstituteRequestToJSON(json: any): UpdateInstituteRequest {
    return UpdateInstituteRequestToJSONTyped(json, false);
}

export function UpdateInstituteRequestToJSONTyped(value?: UpdateInstituteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteName': value['instituteName'],
        'instituteShortName': value['instituteShortName'],
    };
}

